<template>
  <div class="question">
    <AppNavbar :options="options" :zIndex="20" :title="title"> </AppNavbar>
    <div class="content">
      <div class="title">基本信息</div>
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in questionData"
          :key="index"
          @click="bindClickItem(item, index)"
        >
          <div class="item-left">{{ item.field_title }}</div>
          <div
            class="item-center"
            :class="{ gray: item.field_type == 'radio' }"
            >{{ item.valueText }}</div
          >
          <div class="item-right">
            <span v-if="item.field_type == 'int'">{{ item.field_unit }}</span>
            <span
              v-if="item.field_type == 'radio'"
              class="iconfont icon-xiala"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="btn"
      :class="{ 'btn-disabled': disabledSubmit }"
      @click="bindSubmit"
      >生成计算结果</div
    >
    <AppRuler
      v-model="showRuler"
      :title="rulerOptions.field_title"
      :unit="rulerOptions.field_unit"
      :defaultNum="rulerOptions.defaultNum"
      :maxNum="rulerOptions.maxNum"
      :minNum="rulerOptions.minNum"
      @confirm="bindConfirm"
    />
    <RadioComponent
      v-model="showRadio"
      :title="radioOptions.field_title"
      :columns="radioOptions.field_unit"
      value-key="value"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
    <MyToast
      v-show="toastData.show"
      :title="toastData.title"
      :desc="toastData.desc"
      :confirmText="toastData.confirmText"
      :image="toastData.image"
      @confirm="toastData.confirm"
      @cancel="toastData.cancel"
    ></MyToast>
  </div>
</template>
<script>
import { getQuestionData } from './data'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import MyToast from '@/components/app/toast/confirm-toast.vue'
import AppRuler from '@/components/app/ruler/index.vue'
import RadioComponent from './components/RadioComponent.vue'
export default {
  components: {
    AppNavbar,
    AppRuler,
    RadioComponent,
    MyToast
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent'
      },
      title: '饮食计算器',
      questionData: getQuestionData(),
      disabledSubmit: true,
      showRadio: false,
      showRuler: false,
      rulerOptions: {
        title: '',
        unit: '',
        defaultNum: 50,
        minNum: 0,
        maxNum: 100
      },
      radioOptions: [],
      toastData: {
        show: false,
        title: '温馨提示',
        desc: '',
        confirmText: '好的',
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a9f05b6f9be7d9eee90087be46df1044.png',
        confirm: () => {},
        cancel: () => {}
      }
    }
  },
  watch: {
    questionData: {
      deep: true,
      handler() {
        this.disabledSubmit = !this.checkParams(this.questionData)
      }
    }
  },
  created() {
    this.getUserData()
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    getUserData() {
      this.$http
        .getBaseApp('member/DietCalculate/getUserBodyData', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.questionData.map((item) => {
              if (+res.data[item.field]) {
                let value = parseInt(res.data[item.field])
                item.value = value
                item.valueText = value
                item.defaultNum = value
              }
            })
          }
        })
        .catch(() => {})
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset
      if (scrollTop >= 50) {
        this.options = {
          barBackgroundColor: '#fff',
          color: 'rgba(0,0,0.8)'
        }
      } else {
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, 0)',
          color: 'rgba(0,0,0.8)'
        }
      }
    },
    bindConfirm(value) {
      this.questionData[this.curIndex].value = value
      this.questionData[this.curIndex].valueText = value
      this.questionData[this.curIndex].defaultNum = value
    },
    onConfirm(item) {
      this.questionData[this.curIndex].value = item.key
      this.questionData[this.curIndex].valueText = item.value
      this.showRadio = false
    },
    onCancel() {
      this.showRadio = false
    },
    bindClickItem(item, index) {
      if (item.field_type == 'int') {
        this.rulerOptions = item
        this.showRuler = true
      } else {
        this.radioOptions = item
        this.showRadio = true
      }
      this.curIndex = index
    },
    checkParams(data, showToast) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].value === '') {
          return false
        }
        if (
          (data[i].minNum && data[i].value < data[i].minNum) ||
          (data[i].maxNum && data[i].value > data[i].maxNum)
        ) {
          showToast && this.$toast(data[i].field_title + '不在范围内')
          return false
        }
      }
      return true
    },
    bindSubmit() {
      if (this.disabledSubmit) {
        this.checkParams(this.questionData, true)
        return
      }
      //点击_饮食计算器生成计算结果按钮
      this.$buryPoint('CLICK_JSQ_SHENGCHENG')
      let params = {
        data: this.filterResultData(this.questionData)
      }
      this.$http
        .getBaseApp('member/DietCalculate/createDietCalculate', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.replace({
              path: '/diet-calculator/result',
              query: {
                // id: res.data.data
              }
            })
          } else if (res.code == 40002) {
            this.bindShowBuy()
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //次数用完显示购买会员
    bindShowBuy() {
      this.toastData.desc = `<div style='font-size: 14px;color: rgba(0,0,0,0.6);line-height: 24px;margin-bottom:8px'>您的饮食方案计算次数已达上限</div>
          <div style='font-size: 14px;font-weight: 600;color: rgba(0,0,0,0.8);line-height: 20px;'>升级 <span style="position:relative;z-index:1">WE+减脂会员<span
            style='position:absolute;left:0;bottom:2px;width: 100%;height: 6px;background: #FFDDBE;border-radius: 3px;z-index:-1' ></span></span><br/>畅享无限次计算</div>`
      this.toastData.confirmText = '查看WE+减脂会员权益'
      this.toastData.confirm = async () => {
        this.toastData.show = false
        let version = await this.$betterwe.getAppVersion()
        if (version >= 98) {
          this.$betterwe.vipHomePage()
        } else {
          this.$router.push('/betterwe/vip')
        }
      }
      this.toastData.cancel = () => {
        this.toastData.show = false
      }
      this.toastData.show = true
    },
    //处理问卷结果
    filterResultData(data) {
      let obj = {}
      data.map((item) => {
        obj[item.field] = {
          value: item.value
        }
      })
      console.log(obj)
      return obj
    }
  }
}
</script>
<style lang="scss" scoped>
.question {
  background-color: #f9f9f9;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/be9ad79d435193923146b11c024e9976.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;

  .content {
    margin-top: 107px;
    margin-bottom: 30px;
    width: 335px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 20px 30px;
    box-sizing: border-box;

    .title {
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 22px;
      margin-bottom: 18px;
    }

    .list {
      .item {
        height: 56px;
        background: rgba(247, 247, 249, 0.9);
        display: flex;
        align-items: center;
        padding: 18px;
        box-sizing: border-box;
        border-radius: 12px;
        margin-bottom: 12px;

        .item-left {
          width: 60px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
        }

        .item-center {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
          margin: 0 10px;
          text-align: center;
        }

        .gray {
          color: rgba(0, 0, 0, 0.6);
        }

        .item-right {
          min-width: 24px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.4);
          line-height: 16px;

          .iconfont {
            color: rgba(0, 0, 0, 0.2);
            font-size: 20px;
          }
        }
      }

      .item:last-child {
        margin-bottom: 0;
      }
    }
  }

  .btn {
    text-align: center;
    width: 335px;
    height: 40px;
    background: #6236ff;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 40px;
    margin-bottom: 50px;
  }

  .btn-disabled {
    background: #ccc;
  }
}
</style>
